// Load Styles
import '../scss/main.scss';

// Global vars
let lastScrollToAnchor;
let lastScrollToAnchorPos;

window.addEventListener('DOMContentLoaded', () => {
  function setVw () {
    let vw = document.documentElement.clientWidth / 100;
    document.documentElement.style.setProperty('--vw', `${vw}px`);
  }

  setVw();
  window.addEventListener('resize', setVw);

  // UPB Login Button
  if(document.querySelector('.login-status')) {
    fetch('/index.php?upbloginstatus', {
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    })
      .then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
      .then(response => {
        let loginType, loginLabel;
        if (response.loggedin) {
          loginType = '/login/?logintype=logout';
          loginLabel = 'Logout';
        } else {
          loginType = '/login';
          loginLabel = 'Login';
        }
        document.querySelector('.login-status').innerHTML = `
        <a class="btn-icon-link p-0 text-white" href="${loginType}">
          <svg xmlns="http://www.w3.org/2000/svg" class="icon">
            <use xlink:href="#icon-arrow_forward"></use>
          </svg>
          ${loginLabel}
        </a>`;
      })
      .catch(err => {
        //called when there is an error
        //console.log(err.message);
      });
  }

  if(document.querySelector('.ce-reseacher-profile')) {
    document.querySelector('.ce-reseacher-profile').parentElement.classList.add('mb-0');
  }

  //Removing hyphens if text is copied
  const hyphened = document.querySelector(".hyphened");

  hyphened.addEventListener("copy", (event) => {
    const selection = document.getSelection();
    var result = selection.toString().replace(/(\&shy;|­|&#173;)/gi, "");
    event.clipboardData.setData("text/plain", result);
    event.preventDefault();
  });


});
